import React from 'react';
import { enquireScreen } from 'enquire-js';


import Part1 from './Part1';
import Part2 from './Part2';
import Part3 from './Part3';
import Part4 from '@/components/caseWrapper'
import PriceComp from '@/components/priceComp'


 
import {
    Part1DataSource,
    Part2DataSource,
    Part3DataSource,
    Part4DataSource,
    PriceDataSource
} from './data.source.js';

import './less/antMotionStyle.less';

let isMobile;
enquireScreen((b) => {
  isMobile = b;
});

const location = window.location;

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile,
      show: !location.port, // 如果不是 dva 2.0 请删除
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0)

    // 适配手机屏幕;
    enquireScreen((b) => {
      this.setState({ isMobile: !!b });
    });
    // dva 2.0 样式在组件渲染之后动态加载，导致滚动组件不生效；线上不影响；
    /* 如果不是 dva 2.0 请删除 start */
    if (location.port) {
      // 样式 build 时间在 200-300ms 之间;
      setTimeout(() => {
        this.setState({
          show: true,
        });
      }, 500);
    }
    /* 如果不是 dva 2.0 请删除 end */
  }

  render() {
    const children = [
      <Part1
        id="nuclear-part1"
        key="nuclear-part1"
        dataSource={Part1DataSource}
      />,
      <Part2
        id="nuclear-part2"
        key="nuclear-part2"
        dataSource={Part2DataSource}
      />,
      <Part3
        id="nuclear-part3"
        key="nuclear-part3"
        dataSource={Part3DataSource}
      />,
      <PriceComp
        id="nuclear-price"
        key="nuclear-price"
        isMobile={this.state.isMobile}
        dataSource={PriceDataSource}
      />,
      <Part4
        id="nuclear-part4"
        key="nuclear-part4"
        dataSource={Part4DataSource}
      />,
    ];
    return (
      <div
        className="nuclear-wrapper"
        ref={(d) => {
          this.dom = d;
        }}
      >
        {/* 如果不是 dva 2.0 替换成 {children} start */}
        {this.state.show && children}
        {/* 如果不是 dva 2.0 替换成 {children} end */}
      </div>
    );
  }
}
